export async function redirectToSamsungLoginPage({
  memberInfoData,
  accessToken,
  index,
  id,
}) {
  let currentState = `${accessToken}|`;
  if (id) currentState = `${accessToken}|${id}`;
  const hostname = window.location.hostname;
  const isProd = hostname === "hkclubs.samsung.com";

  const redirectUri = isProd
    ? `https://hkclubs.samsung.com/ClubsAPI/SSORedirect/${index}`
    : `https://hkclubs.local.opentide.com.cn/ClubsAPI/SSORedirect/${index}`;


  try {
    const sal = await samsungaccount.SamsungAccountClient.createSamsungAccountClient(
      {
        // clientId: "l7clvyrrhs",
        clientId: "85lpzisaun",
      }
    );
    await sal.signInRedirect({
      //redirectUri: `https://hkclubs.local.opentide.com.cn/ClubsAPI/SSORedirect/${index}`,
      redirectUri,
      responseType: "code",
      state: memberInfoData ? currentState : `|${id}`,
    });
    console.log(memberInfoData);
  } catch (error) {
    console.error("Samsung login error:", error);
  }
}
